import { createContext, Dispatch, SetStateAction } from 'react'

import { ExclusionForm } from '../types'

export const defaultExclusionForm: ExclusionForm = {
	phone_number: '',
	name: '',
	notes: '',
}

export const ExclusionListFormContext = createContext<{
	exclusionForm: ExclusionForm
	setExclusionForm: Dispatch<SetStateAction<ExclusionForm>>
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	showError: boolean
	setShowError: Dispatch<SetStateAction<boolean>>
}>({
	exclusionForm: defaultExclusionForm,
	setExclusionForm: () => {},
	formEdited: false,
	setFormEdited: () => {},
	showError: false,
	setShowError: () => {},
})
